<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            class="queryform_div"
            label-width="120px"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('title.productLine')" >
                  <el-select
                    v-model="formselect.productLine"
                    style="width: 100%"
                    size="small"
                    @change="changeProductLine"
                  >
                    <el-option :label="$t('desc.all')" value="All"></el-option>
                    <el-option
                      v-for="item in productLineArr"
                      :key="item.bnDictCode"
                      :label="item.bnDictName"
                      :value="item.bnDictCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.region')">
                  <el-select
                    v-model="formselect.customerRegionId"
                    filterable
                    @change="resetCenter"
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in region" 
                      :value="item.parentId"
                      :label="item.area"
                      :key="'inx1' + index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.customerCenter')">
                  <el-select
                    v-model="formselect.customerCenterRegionId"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in center"
                      :value="item.id"
                      :label="item.center"
                      :key="'inx2' + index"
                      v-if="item.parentId == formselect.customerRegionId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="24" :xs="24" style="margin-top: 10px">
                <el-button @click="getData('search')" type="primary" size="small">{{
                  $t("button.query")
                }}</el-button>
                <el-button @click="reset" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <template>
            <el-button
              v-if="hasCreateAuth"
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="add"
              style="margin-bottom: 10px"
              >{{ $t("title.AddAlarmReceiver") }}
            </el-button>
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                v-loading="loading"
                style="width: 100%"
                class="alarmTable"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="contactType"
                  :label="$t('title.productLine')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.contactType == 'Other'">
                      Rotary
                    </span>
                    <span v-else-if="scope.row.contactType == 'All' || scope.row.contactType === '全部'">{{
                      $t("desc.all")
                    }}</span>
                    <span v-else>{{ scope.row.contactType }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="customerRegionName"
                  :label="$t('title.area')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.customerRegionName == '全部' || scope.row.customerRegionId === 'All'">{{
                      $t("desc.all")
                    }}</span>
                    <span v-else>{{ scope.row.customerRegionName }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="authType"
                  :label="$t('title.authType')"
                  width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.authType == '全部'">{{
                      $t("desc.all")
                    }}</span>
                    <span v-else>{{ $t("desc." + scope.row.authType) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="list"
                  min-width="300px"
                  :label="$t('desc.authList')"
                >
                  <template slot-scope="scope">
                    <div
                      v-for="item in scope.row.relateData.slice(0, 4)"
                      :key="item.id"
                    >
                      {{ id2Display(scope.row.authType, item) }}
                    </div>
                    <el-tooltip  placement="right-start" v-if="scope.row.relateData.length > 4">
                      <div slot="content" style="margin-left:100px;max-height: 600px; min-width:350px;overflow: auto; margin:10px;">
                          <div
                            v-for="item in scope.row.relateData"
                            :key="item.id"
                          >
                           <div style="margin:10px;"> {{ id2Display(scope.row.authType, item) }}</div>
                          </div>
                      </div>
                      <div class="list-ellipsis"> ... </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="AlarmReceiver"
                  :label="$t('title.AlarmReceiver')"
                  min-width="150"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.creationTime')"
                  width="90"
                >
                  <template slot-scope="scope">
                    {{scope.row.creationtime | dateFormat}}
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('title.operate')"
                  width="110"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      v-if="hasUpdateAuth"
                      type="primary"
                      icon="el-icon-edit"
                      :title="$t('button.update')"
                      circle
                      size="mini"
                      @click="edit(scope.row)"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="delUser(scope.row.id)"
                        v-if="hasDeleteAuth"
                      >
                        <el-button
                          
                          type="danger"
                          icon="el-icon-delete"
                          :title="$t('button.delete')"
                          circle
                          size="mini"
                          slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pagination.totalPage"
                :current-page.sync="pagination.current"
                :page-size="pagination.pageSize"
                @current-change="getData()"
                style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <el-dialog
      :title="$t('title.AlarmReceiver')"
      :visible.sync="dialog"
      v-if="dialog"
      width="60%"
      top="5vh"
    >
      <el-form ref="AlarmRform" :model="AlarmRform" label-width="160px":rules="rules">
        <el-row :gutter="24">
          <el-col :xs="24">
            <el-form-item :label="$t('title.brand')" prop="brandCode">
              <el-select style="width: 50%" @change="changeBrand" v-model="AlarmRform.brandCode" :placeholder="$t('desc.select')">
                <el-option 
                  :label="brandInfo.brandName"
                  :value="brandInfo.brandCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item :label="$t('title.productLine')" prop="productLine">
              <el-select style="width: 50%" @change="changeProductLineDia" v-model="AlarmRform.productLine" :placeholder="$t('desc.select')">
                <el-option :label="$t('desc.all')" value="All"></el-option>
                <el-option
                      v-for="item in productLineArr"
                      :key="item.bnDictCode"
                      :label="item.bnDictName"
                      :value="item.bnDictCode"
                    >
                    </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item :label="$t('title.area')" prop="customerRegionId">
              <el-select
                v-model="AlarmRform.customerRegionId"
                :placeholder="$t('desc.select')"
                style="width: 50%"
                @change="changeArea"
              >
                <el-option
                  value="All"
                  :label="$t('desc.all')"
                ></el-option>
                <el-option
                  v-for="(item, index) in regionOption"
                  :value="item.parentId"
                  :label="item.area"
                  :key="'inx1' + index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item :label="$t('title.authType')" prop="authType">
              <el-select
                v-model="AlarmRform.authType"
                :placeholder="$t('desc.select')"
                style="width: 50%"
                @change="changeAccountType"
              >
                <el-option :label="$t('desc.customer')" value="customer"></el-option>
                <el-option :label="$t('desc.equipment')" value="equipment"></el-option>
                <el-option :label="$t('title.customerCenter')" value="customerCenter"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" v-if="AlarmRform.authType == 'customer'">
            <el-form-item :label="$t('desc.customer')" prop="relateDataCustomer">
              <!-- :rules="[{ required: true, message: $t('tips.needed') }]" -->
              <el-select
                v-model="AlarmRform.relateData"
                filterable
                multiple
                remote
                reserve-keyword
                :remote-method="remoteMethod"
                :loading="loading1"
                :placeholder="$t('desc.select')"
                style="width: 100%"
                value-key="id"
              >
                <el-option
                  v-for="item in custOptionsShow"
                  :key="item.id"
                  :value="item"
                  :label="containTranslate(item.label)"
                >
                  <span style="float: left; margin-right: 5px">{{
                    containTranslate(item.label)
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" v-else-if="AlarmRform.authType == 'equipment'">
            <el-form-item :label="$t('desc.equipment')" prop="relateDataEquipment">
            <!-- :rules="[{ required: true, message: $t('tips.needed') }]" -->
              <el-select
                v-model="AlarmRform.relateData"
                filterable
                multiple
                remote
                reserve-keyword
                :remote-method="remoteDsnMethod"
                :loading="loading1"
                :placeholder="$t('desc.select')"
                style="width: 100%"
                value-key="id"
              >
                <el-option
                  v-for="(item, index) in dsnOptionShow"
                  :key="item.id"
                  :value="item"
                  :label="item.label"
                >
                  <span style="float: left; margin-right: 5px">{{
                    item.label
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" v-else-if="AlarmRform.authType == 'customerCenter'">
            <el-form-item :label="$t('title.customerCenter')" prop="relateDataCenter">
              <el-select
                v-model="AlarmRform.relateData"
                :placeholder="$t('desc.select')"
                style="width: 50%"
                multiple
              >
                <!-- <el-option
                  value="00000000-0000-0000-0000-000000000000"
                  :label="$t('desc.all')"
                ></el-option> -->
                <el-option
                  v-for="(item, index) in center"
                  :value="item.id"
                  :label="item.center"
                  :key="'inx2' + index"
                  v-if="AlarmRform.customerRegionId === 'All' || item.parentId == AlarmRform.customerRegionId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" v-else style="height: 20px;">
          </el-col>
          <!--                    <el-col :xs="24">-->
          <!--                        <el-form-item :label="$t('desc.customer')">-->
          <!--                            <el-select-->
          <!--                                    v-model="AlarmRform.value3"-->
          <!--                                    :placeholder="$t('desc.select')"-->
          <!--                                    style="width: 50%"-->
          <!--                            >-->
          <!--                                <el-option value="河北双吉化工有限公司">河北双吉化工有限公司</el-option>-->
          <!--                                <el-option value="崇利制钢">崇利制钢</el-option>-->
          <!--                                <el-option value="1XXXXXXXXXXXXXXX">1XXXXXXXXXXXXXXX</el-option>-->
          <!--                                <el-option value="2XXXXXXXXXXXXXXX">2XXXXXXXXXXXXXXX</el-option>-->
          <!--                                <el-option value="3XXXXXXXXXXXXXXX">3XXXXXXXXXXXXXXX</el-option>-->
          <!--                                <el-option value="4XXXXXXXXXXXXXXX">4XXXXXXXXXXXXXXX</el-option>-->
          <!--                                <el-option value="5XXXXXXXXXXXXXXX">5XXXXXXXXXXXXXXX</el-option>-->
          <!--                            </el-select>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <el-col :xs="24">
            <el-form-item :label="$t('title.AlarmReceiver')" prop="contacts">
              <el-select
                v-model="AlarmRform.contacts"
                multiple=""
                filterable
                :placeholder="$t('desc.select')"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in managerList"
                  :value="item.id"
                  :label="item.name"
                  :key="'inx3' + index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24">
            <el-form-item :label="$t('title.InformationPush')">
              <el-checkbox v-model="checked1" disabled>{{
                $t("lable.BusinessPush")
              }}</el-checkbox>
              <el-checkbox v-model="checked2">{{
                $t("lable.NoticPush")
              }}</el-checkbox>
              <el-checkbox v-model="checked3">{{
                $t("lable.EmailPush")
              }}</el-checkbox>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24">
            <el-form-item>
              <el-button type="success" @click="onSubmit">{{
                $t("button.confirm")
              }}</el-button>
              <el-button @click="dialog = false">{{
                $t("button.cancel")
              }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  GetAllAlarmRules,
  getCustomerRegionTable,
  CreateAlarmRules,
  GetAllManererUser,
  UpdateAlarmRules,
  DeleteAlarmRules,
  authOperationCheck,
  getBrandInfos,
  getProductLines,
  getAllCustomer,
  GetAllDevice,
  getCustomerOptions,
  getDeviceOptions
} from "../../api/api";
import { getItemFormLocalstorage } from "../../../utils/package-localstorage";
export default {
  name: "index",

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  data() {
    const validateRelateData = (rule, value, callback) => {
      // 判断至少有一项被选中
      if (
        this.AlarmRform.relateData &&
        this.AlarmRform.relateData.length > 0
      ) {
        callback();
      } else {
        callback(new Error(this.$t('tips.needed')));
      }
    };
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      btn: "",
      dialog: false,
      loading: false,
      formselect: {
        customerRegionId: "",
        customerCenterRegionId: "",
        productLine:"All"
      },
      tableData1: [],
      AlarmRform: {
        id: "",
        brandCode: "",
        productLine: "",
        customerRegionId: "",
        authType: "",
        relateData: "",

        // customerCenterRegionId: "",
        contacts: [],
        noticeEnable: this.checked1,
        appEnable: "",
        emailEnable: "",
      },
      rules: {
        brandCode: [
          { required: true, message: this.$t('tips.needed'), trigger: 'submit' }
        ],
        productLine: [
          { required: true, message: this.$t('tips.needed'), trigger: 'submit' }
        ],
        customerRegionId: [
          { required: true, message: this.$t('tips.needed'), trigger: 'submit' }
        ],
        authType: [
          { required: true, message: this.$t('tips.needed'), trigger: 'submit' }
        ],
        contacts: [
          { required: true, message: this.$t('tips.needed'), trigger: 'submit' }
        ],
        relateDataCustomer: [
          { validator: validateRelateData, trigger: 'submit' }
        ],
        relateDataEquipment: [
          { validator: validateRelateData, trigger: 'submit' }
        ],
        relateDataCenter: [
          { validator: validateRelateData, trigger: 'submit' }
        ]
      },
      region: [],
      regionOption:[],
      center: [],
      managerList: [],
      checkList: ["1"],
      checked1: true,
      checked2: false,
      checked3: true,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      loginUserName: "",
      roleList: "",
      brandInfo:{},
      centerList:[],
      customerList: [],
      dsnOption: [],
      productLineArr:[],
      loading1: false,
      selectPageSize: 30,
      custOptions: [],
      custOptionsShow: [],
      dsnOptionShow: [],
      accountInfo: {},
      customerKeySearch: "",
      deviceKeySearch: "",
    };
  },

  created: function () {
    this.authOperation("AlarmRules");
    this.loginUserName = getItemFormLocalstorage("userName");
    this.roleList = getItemFormLocalstorage("roles");
  },

  mounted() {
    this.getData();
    this.getProductLines();
    this.getRegion();
    // this.getCustomerAll();
    // this.getAllDevice();
    this.getAllUser();
    this.getBrandInfos();
  },
  // 监听dialog关闭事件，关闭则accountInfo={}
  watch: {
    dialog(val) {
      if (!val) {
        this.accountInfo = {};
      }
    },
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
    },
    async getProductLines(){
      let that=this;
      let res = await getProductLines();
      that.productLineArr = res.result;
    },
    async getBrandInfos(){
      let that=this;
      let res = await getBrandInfos();
      let brandCode=localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR";
      that.brandInfo = res.result.find(x=>x.brandCode==brandCode);
    },
    changeBrand(){
      // this.regionOption=JSON.parse(JSON.stringify(this.region));
    },
    getAllUser() {
      var that = this;
      GetAllManererUser().then((res) => {
        if (res.success) {
          that.managerList = res.result;
        }
      });
    },
    reset() {
      this.formselect = {
        customerRegionId: "",
        customerCenterRegionId: "",
        productLine:"All"
      };
      this.getData();
    },
    resetCenter() {
      this.$set(this.formselect, "customerCenterRegionId", "");
    },
    //删除
    delUser(e) {
      DeleteAlarmRules(e)
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t("tips.deleteSuccess"));
            this.getData();
          } else {
            this.$message.error(res.error.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.error.message);
        });
    },
    //数组对象去重
    reduce(config) {
      var hash = {};
      const newArr = config.reduceRight((item, next) => {
        hash[next.area] ? "" : (hash[next.area] = true && item.push(next));
        return item;
      }, []);
      return newArr;
    },
    //获取地区
    getRegion() {
      var that = this;
      getCustomerRegionTable()
        .then((res) => {
          if (res.success) {
            this.centerList = res.result.centerList;
          } else {
            this.$message.error(res.error.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.error.message);
        });
    },
    changeArea() {
      this.$set(this.AlarmRform, "relateData", []);
      if(this.AlarmRform.authType == "customer") {
        this.getCustomerOptions()
      } else if(this.AlarmRform.authType == "equipment") {
        this.getDeviceOptions()
      }

    },
    //用来判断在编辑时
    changeAccountType(){
      let that = this;
      if (Object.keys(that.accountInfo).length === 0) {
        that.$set(that.AlarmRform, "relateData", []);
      } else if (that.accountInfo.authType == that.AlarmRform.authType) {
        let relateData = that.accountInfo.relateData;
        that.$set(that.AlarmRform, "relateData", relateData);
      } else {
        that.$set(that.AlarmRform, "relateData", []);
      }
      if(that.AlarmRform.authType == "customer") {
        that.getCustomerOptions()
      } else if(that.AlarmRform.authType == "equipment") {
        that.getDeviceOptions()
      }
    },
    containTranslate(str) {
      let containArr = ['直管', '经销商', '服务经销商', '中间商', '其他', '直销'];
      let result="";
      containArr.forEach(element=>{
        if (str.indexOf(element) > -1) {
          let displayStr = this.$t('desc.'+element);
          result = str.replace(element,displayStr);
        }
      });
      return result;
    },

    async getCustomerOptions() {
      var that = this;
      let productLine = this.AlarmRform.productLine == "All" ? "" : this.AlarmRform.productLine;
      let customerRegionId = this.formselect.customerRegionId == "All" ? "" : this.formselect.customerRegionId;
      await getCustomerOptions(
        this.customerKeySearch,
        productLine,
        customerRegionId
      ).then((res) => {
        if (res.success) {
          that.customerList = res.result;
          that.custOptions = that.customerList.map((item) => {
            return {
              id: `${item.id}`,
              label: `${
                item.customerCode +
                "_" +
                item.customerName +
                "_" +
                item.companyType +
                "_" +
                item.manageCpName
              }`,
            };
          });
          //对于relateData中每个item，如果不包含在this.custOptions中中，则添加到this.custOptionsShow中
          that.AlarmRform.relateData.forEach(item => {
            if (!that.custOptions.some((x) => x.id == item.id)) {
              that.custOptions.push(item);
            }
          })
          that.$set(that, 'custOptionsShow', [...that.custOptions]);

        }
      });
    },

    async getDeviceOptions(){
      let productLine = this.AlarmRform.productLine == "All" ? "" : this.AlarmRform.productLine;
      let customerRegionId = this.AlarmRform.customerRegionId == "All" ? "" : this.AlarmRform.customerRegionId;
      await getDeviceOptions(
        this.deviceKeySearch,
        productLine,
        customerRegionId
      ).then((res) => {
        this.dsnOption = res.result.map((item) => {
          return {
            id: `${item.id}`,
            label: `${item.dsn} (${item.customerName})`,
          };
        });
        
        this.AlarmRform.relateData.forEach(item => {
          if (!this.dsnOption.some(x => x.id == item.id)) {
            this.dsnOption.push(item);
          }
        })
        this.$set(this, 'dsnOptionShow', [...this.dsnOption]);
      });
    },

    loadMore(n) {
      return () => (this.selectPageSize += 5); // 每次滚动到底部可以新增条数  可自定义
    },
    
    remoteMethod(query) {
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.customerKeySearch = query;
          this.getCustomerOptions();
          this.loading1 = false;
        }, 200);
      } else {
        this.custOptionsShow = this.custOptions;
      }
    },
    remoteDsnMethod(query){
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.deviceKeySearch = query;
          this.getDeviceOptions();
          this.loading1 = false;
        }, 200);
      } else {
        this.dsnOptionShow = this.dsnOption;
      }
    },

    id2Display(type, item){
      if (type == "customerCenter") {
        if (!Array.isArray(this.centerList) || this.centerList.length === 0) {
          return "";
        }
        const curCenter = this.centerList.find(a=> a.id == item)
        if (curCenter.regionType == "Other") {
          return "Rotary" + '/' + curCenter.center
        }
        return curCenter.regionType + '/' + curCenter.center
      } else if (type == "customer") {
        return item.label ? this.containTranslate(item.label) : item.label;
      } else if (type == "equipment") {
        return item.label
      }
    },
    add() {
      this.selectPageSize = 30;
      this.regionOption=new Array();
      this.btn = "add";
      this.dialog = true;
      this.deviceKeySearch = "";
      this.customerKeySearch = "";
      this.$set(this.AlarmRform, "relateData", []);
      this.AlarmRform = {
        brandCode: localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR",
        customerRegionId: "",
        authType: "",
        relateData: "",

        // customerCenterRegionId: "",
        contacts: [],
        noticeEnable: this.checked1,
        appEnable: "",
        emailEnable: "",
        productLine:"",
      };
      
    },
    edit(e) {
      this.accountInfo = e;
      this.selectPageSize = 30;
      this.regionOption=new Array();
      this.btn = "edit";
      this.deviceKeySearch = "";
      this.customerKeySearch = "";
      this.AlarmRform.brandCode=e.brandCode;
      this.AlarmRform.productLine = e.contactType;
      this.AlarmRform.customerRegionId = e.customerRegionId;
      this.AlarmRform.id = e.id;
      this.AlarmRform.authType = e.authType;

      //获取大区和客户中心可选项
      let centList = []
      if (this.AlarmRform.productLine ===  "All") {
        centList = this.centerList
        this.center = JSON.parse(JSON.stringify(centList));

        let region = this.reduce(centList);
        this.regionOption = JSON.parse(JSON.stringify(region));
      } else {
        centList = this.centerList.filter(x=>x.regionType == this.AlarmRform.productLine);
        this.center = JSON.parse(JSON.stringify(centList));

        let region = this.reduce(centList);
        let regionOption = region.filter(x=>x.regionType == this.AlarmRform.productLine);
        this.regionOption = regionOption;
      }
      
      if (typeof e.relateData === 'string' && e.relateData.trim() !== '') {
        this.AlarmRform.relateData = JSON.parse(e.relateData);
      } else {
        this.AlarmRform.relateData = e.relateData;
      }
      // console.log("this.AlarmRform.relateData", this.AlarmRform.relateData);
      if (e.authType == "customerCenter") {
      } else if (e.authType == "customer") {
        this.getCustomerOptions();
      }else if (e.authType == "equipment") {
        this.getDeviceOptions();
      }

      this.AlarmRform.noticeEnable = e.noticeEnable;
      this.AlarmRform.appEnable = e.appEnable;
      this.AlarmRform.emailEnable = e.emailEnable;
      this.checked1 = e.noticeEnable;
      this.checked2 = e.appEnable;
      this.checked3 = e.emailEnable;
      this.AlarmRform.contacts = JSON.parse(e.contacts).map((item) => item.Id);
      this.changeBrand();
      this.dialog = true;
    },
    getData(type = "normal") {
      this.loading = true;
      if (type == "search") {
        this.pagination.current = 1;
      }
      var data = {
          customerRegionId: "",
          customerCenterRegionId: "",
          skipCount: (this.pagination.current - 1) * 10,
        },
        that = this;
      data = { ...data, ...this.formselect };
      GetAllAlarmRules(data).then((res) => 
        {
          if (res.success) {
            const tableData = res.result.items || [];
            this.loading = false;
            // 合并所有逻辑到一次遍历
            this.tableData1 = tableData.map((item) => {
                return {
                  ...item,
                  AlarmReceiver: (item.userJson || []).map((i) => i.userName).join(";"),
                  relateData: this.safeParseJson(item.relateData || ''),
                  isOptions: this.roleList?.includes("Admin") || 
                          (item.AlarmReceiver || '').includes(this.loginUserName || '')
                };
            });
            // console.log('this.tableData1',this.tableData1);
            this.pagination.totalPage = res.result.totalCount || 0;
          } else {
            this.handleErrorMessage(res.error.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.error.message);
          this.loading = false;
        });
    },
    // 辅助方法：安全解析 JSON
    safeParseJson(jsonString) {
      try {
        return jsonString.trim() !== '' ? JSON.parse(jsonString) : [];
      } catch (e) {
        console.error('JSON 解析失败:', e);
        return [];
      }
    },
      // GetAllAlarmRules(data)
      //   .then((res) => {
      //     if (res.success) {
      //       that.tableData1 = res.result.items;
      //       console.log('res.result.items',res.result.items);
      //       that.tableData1.map((item) => {
      //         item.AlarmReceiver = item.userJson
      //           .map((i) => i.userName)
      //           .join(";");
      //       });

      //       that.tableData1.map((e) => {
      //         if (typeof e.relateData === 'string' && e.relateData.trim() !== '') {
      //           e.relateData = JSON.parse(e.relateData);
      //         } else {
      //           e.relateData = [];
      //         }
      //       });
            
      //       that.tableData1.map((item) => {
      //         if (this.roleList.indexOf("Admin") != -1) {
      //           item.isOptions = true;
      //         } else if (item.AlarmReceiver.indexOf(this.loginUserName) != -1) {
      //           item.isOptions = true;
      //         }
      //       });
      //       this.pagination.totalPage = res.result.totalCount;
      //       this.loading = false;
      //     } else {
      //       this.$message.error(res.error.message);
      //       this.loading = false;
      //     }
      //   })
      //   .catch((err) => {
      //     this.$message.error(err.error.message);
      //     this.loading = false;
      //   });
      // },
    handleAccredit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    reserCheckBox() {
      this.checked1 = true;
      this.checked2 = false;
    },
    onSubmit() {
      this.$refs.AlarmRform.validate((valid) => {
        if (valid) {
          this.AlarmRform.noticeEnable = this.checked1;
          this.AlarmRform.appEnable = this.checked2;
          this.AlarmRform.emailEnable = this.checked3;

          let alarmForm = JSON.parse(JSON.stringify(this.AlarmRform));
          alarmForm.relateData = JSON.stringify(this.AlarmRform.relateData);
          let data = JSON.parse(JSON.stringify(alarmForm));
          let that = this;
          data.contacts = data.contacts.join(";");
          if (that.btn == "add") {
            delete data.id;
            CreateAlarmRules(data)
              .then((res) => {
                if (res.success) {
                  that.$message.success("success");
                  that.dialog = false;
                  that.reserCheckBox();
                  that.getData();
                } else {
                  that.$message.error(res.error.message);
                }
              })
              .catch((err) => {
                that.$message.error(err.error.message);
              });
          } else {
            UpdateAlarmRules(data)
              .then((res) => {
                if (res.success) {
                  that.$message.success("success");
                  that.dialog = false;
                  that.reserCheckBox();
                  that.getData();
                } else {
                  that.$message.error(res.error.message);
                }
              })
              .catch((err) => {
                that.$message.error(err.error.message);
              });
          }
        } else {
          console.log('error submit!');
          return false;
        }
      });
    },
    changeProductLine(){
      let that = this;
      that.formselect.customerRegionId ="";
      that.formselect.relateData  ="";
      let centList = this.centerList.filter(x=>x.regionType == that.formselect.productLine)
      that.center = JSON.parse(JSON.stringify(centList));
      that.region = this.reduce(centList);
    },
    changeProductLineDia(){
      let that = this;
      that.AlarmRform.customerRegionId ="";
      that.AlarmRform.relateData  ="";

      let centList = []
      if (that.AlarmRform.productLine ===  "All") {
        centList = that.centerList
        that.center = JSON.parse(JSON.stringify(centList));
        let region = this.reduce(centList);
        that.regionOption=JSON.parse(JSON.stringify(region));
      } else {
        centList = that.centerList.filter(x=>x.regionType == that.AlarmRform.productLine);
        that.center = JSON.parse(JSON.stringify(centList));
        let region = this.reduce(centList);
        let regionOption = region.filter(x=>x.regionType == that.AlarmRform.productLine);
        that.regionOption=JSON.parse(JSON.stringify(regionOption));
        // 这里的region和全局的不是一个意思，全局的是查询时的大区可选项， regionOption是表单的大区可选项
      }
    },
  },
  //自定义指令-实现下拉框滚动翻页
  directives: {
    "el-select-loadmore": (el, binding) => {
      const SELECTWRAP_DOM = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const condition =
            this.scrollHeight - this.scrollTop - 10 <= this.clientHeight;
          if (condition) binding.value();
        });
      }
    },
  },
};
</script>

<style scoped>
.list-ellipsis {
  display: block; 
  overflow: hidden;
  margin: 3px 0px; 
  padding: 0px 1px 2px 1px;
  border-radius: 8px;
  line-height: 1px;
  height: 15px;
  width: 40px;
  font-size: 24px;
  text-align: center;
  cursor: pointer;
  background-color: #4a5052;
  color: #dde7ec;
}
</style>
